// extracted by mini-css-extract-plugin
module.exports = {"pin":"_99551c8aa8--pin--Jw9Rq","pin_active":"_99551c8aa8--pin_active--LKZ9V"};